import axios from '@/api/axios';

const getCompanyList = () => axios.get('/administration/company');

const getUserList = (
  search = undefined,
  company_ids = undefined,
  limit = undefined,
  offset = undefined
) => {
  let args = {};
  if (search) args.search = search;
  if (limit) args.limit = limit;
  if (offset) args.offset = offset;
  if (company_ids && company_ids.length) args.company_ids = company_ids.join(',');
  return axios.get('/administration/user', {params: args});
};

const toggleUserBanState = (uid, banned) =>
  axios.post(`/administration/user/${uid}/toggle-ban/${banned ? 'ban' : 'unban'}`);

const toggleUserImp = (uid, action) =>
  axios.post(`/administration/user/${uid}/impersonate/${action}`);

const toggleUserAdmin = (uid, action) => axios.post(`/administration/user/${uid}/admin/${action}`);

const toggleUserPlatformAdmin = (uid, action) =>
  axios.post(`/administration/user/${uid}/platform-admin/${action}`);

const changeUserEmail = (uid, new_email) =>
  axios.post(`/administration/user/${uid}/change-email/${new_email}`);

const changeUserName = (uid, data) => axios.post(`/administration/user/${uid}/change-name`, data);

export default {
  getCompanyList,
  getUserList,

  toggleUserBanState,
  toggleUserImp,
  toggleUserAdmin,
  toggleUserPlatformAdmin,

  changeUserEmail,
  changeUserName,
};
